import React from 'react';

import { Stack, Typography } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import StatCard from './StatCard';

interface ExtranetApprovalsPageHeaderProps {
  pendingCount: number;
  homesVillasPendingCount: number;
}

export default function ExtranetApprovalsPageHeader({
  pendingCount,
  homesVillasPendingCount,
}: ExtranetApprovalsPageHeaderProps) {
  return (
    <>
      <PageSubheader title="Extranet — change approvals" />

      <Typography variant="body2" color="text.secondary" mb={2} maxWidth={680}>
        Review pending Extranet edits submitted by partners across Rooms, Description, Policies, Property Details,
        Taxes, Facilities, and Images. Approve applies accepted changes to the live listing and records them as
        approved.
      </Typography>

      <Stack direction="row" spacing={2} flexWrap="wrap" mb={3}>
        <StatCard label="Pending changes" value={pendingCount} hint="All Extranet tabs" />
        <StatCard label="Homes & Villas pending" value={homesVillasPendingCount} hint="Dedicated queue" />
      </Stack>
    </>
  );
}
